import React from "react";
import AcceptAutoFinanceWrapper from "../AcceptAutoFinance.styles";
import { Paragraph } from "@components/paragraph";
import SectionHeading from "@components/sectionHeading";
import environmentSettings from "@src/constants/environmentSettings";

export default function FailedClientMessage() {
  const { phone } = environmentSettings;
  
  return (
    <AcceptAutoFinanceWrapper maxWidth="720px">
        <SectionHeading heading="An issue has occurred"/>
        <Paragraph size="p0" textAlign="center">
            Apologies, there is an issue accepting your offer. Please check your link is valid and try again.
        </Paragraph>
        <Paragraph size="p0" textAlign="center">
            If you need any assistance, please call us on <a href={`tel:${phone}`}>{phone}</a>.
        </Paragraph>
    </AcceptAutoFinanceWrapper>
  );
}
